const { zipCodeRegexNumeric, onlyNumericNormalize } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 4);

exports.countryDefinition = {
  country: 'Hungary',
  code: 'HU',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'City/Town' },
    zipCode: { label: 'Postcode', normalize: exports.zipCodeNormalize }
  },
  viewFormat: [['company'], ['city'], ['address'], ['address2'], ['zipCode']],
  formFormat: [['company'], ['city'], ['address'], ['address2'], ['zipCode']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(4)),
      error: 'Must be 4 characters, 1234'
    }
  ]
};
